import { create } from "zustand";
import { CustomerData, CustomerDataSearchParams } from "../../types";
import { getDateInputValue } from "../lib/date";

interface CustomerDataState {
  customerData: CustomerData[];
  setCustomerData: (invoices: CustomerData[]) => void;
  loading: boolean;
  customerDataLoaded: boolean;
  setCustomerDataLoaded: (loaded: boolean) => void;
}

const generateCustomerDataSet = ({customerDataLoadedInitial = false} = {}) => (set: any) => ({
  customerData: [],
  loading: true,
  setCustomerData: (customerData: CustomerData[]) => set({ customerData, loading: false }),
  customerDataLoaded: customerDataLoadedInitial,
  setCustomerDataLoaded: (customerDataLoaded: boolean) => set({ customerDataLoaded }),
})

export const useCustomerData = create<CustomerDataState>(generateCustomerDataSet());


interface CustomerDataSearchParamsState {
  customerDataSearchParams: CustomerDataSearchParams;
  setCustomerDataSearchParams: (customerDataSearchParams: CustomerDataSearchParams) => void;
  activePage: number;
  setActivePage: (activePage: number) => void;
  pageSize: number;
  setPageSize: (pageSize: number) => void;
  sortField: string;
  setSortField: (sortField: string) => void;
  sortOrder: string;
  setSortOrder: (sortOrder: string) => void;
}

const customerDataSearchParamsSet = (set: any) => ({
  customerDataSearchParams: {startDate: getDateInputValue(30), endDate: getDateInputValue(0), producerLocationKey: null},
  setCustomerDataSearchParams: (customerDataSearchParams: CustomerDataSearchParams) => set({ customerDataSearchParams }),
  activePage: 1,
  setActivePage: (activePage: number) => set({ activePage }),
  pageSize: 10,
  setPageSize: (pageSize: number) => set({ pageSize }),
  sortField: 'totalOrderCount',
  setSortField: (sortField: string) => set({ sortField }),
  sortOrder: 'DESC',
  setSortOrder: (sortOrder: string) => set({ sortOrder })
  });

export const useCustomerDataSearchParams = create<CustomerDataSearchParamsState>(customerDataSearchParamsSet);